class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    const varOptions = this.querySelector("select");
    const productForm = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    const input = productForm?.querySelector('input[name="id"]');

    if (input && varOptions) {
      input.value = varOptions.value;
    }
  }
}

customElements.define("sticky-variant-select", StickyProVariantSelect);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", stickyScroll);
  document.addEventListener("shopify:section:select", stickyScroll);
  document.addEventListener("shopify:section:deselect", stickyScroll);
}

function syncStickyVariant() {
  const stickyInput = document.querySelector("#sticky__selected_variant_id");
  const mainForm = document.querySelector(".product_buy_button_form");
  const mainInput = mainForm?.querySelector('input[name="id"]');

  if (stickyInput && mainInput && mainInput.value) {
    stickyInput.value = mainInput.value;
  }
}

function stickyScroll() {
  const stickySelectedVariant = document.querySelector("#sticky__variant");
  const stickySelectVariantInput = document.querySelector(
    "#sticky__selected_variant_id"
  );

  if (stickySelectedVariant && stickySelectVariantInput) {
    stickySelectVariantInput.value = stickySelectedVariant.value;
  }

  const buyButtonForm = document.querySelector(".product_buy_button_form");
  const productStickyWrapper = document.querySelector(".product__sticky");

  if (!buyButtonForm || !productStickyWrapper) return;

  syncStickyVariant();

  const updateStickyState = () => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const buyButtonOffset = TopOffset(buyButtonForm);
    const buyButtonTop = buyButtonOffset?.top || 0;

    if (isMobile && window.scrollY > buyButtonTop) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  };

  window.addEventListener("scroll", updateStickyState, { passive: true });
  window.addEventListener("resize", updateStickyState);

  document.addEventListener("change", () => {
    setTimeout(syncStickyVariant, 50);
  });

  document.addEventListener("variant:change", (event) => {
    const variantId = event?.detail?.variant?.id;
    const stickyInput = document.querySelector("#sticky__selected_variant_id");

    if (variantId && stickyInput) {
      stickyInput.value = variantId;
    } else {
      setTimeout(syncStickyVariant, 50);
    }
  });

  updateStickyState();
}

stickyScroll();
